import { ArgumentValidator } from '@/shared/helpers';
import { AxiosInstance } from 'axios';
import { IActivityAttendance } from '../models/activity-attendance';

export class AttendanceClient {

    constructor(private axiosClient: AxiosInstance) { }

    public get apiUrl() {
        return `/attendance`;
    }

    public async getAttendingCount(activityId: string): Promise<number> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);

        const response = await this.axiosClient.get(
            `${this.apiUrl}/${activityId}/attendingCount`
        );

        return response.data;
    }

    public async get(activityId: string): Promise<IActivityAttendance> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);

        const response = await this.axiosClient.get(
            `${this.apiUrl}/${activityId}`
        );

        return response.data;
    }

    public async accept(activityId: string): Promise<IActivityAttendance> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);

        const response = await this.axiosClient.post(
            `${this.apiUrl}/${activityId}/accept`
        );

        return response.data;
    }

    public async neglect(activityId: string): Promise<IActivityAttendance> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);

        const response = await this.axiosClient.post(
            `${this.apiUrl}/${activityId}/neglect`
        );

        return response.data;
    }

    public async attending(activityId: string, userId: string): Promise<IActivityAttendance> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);
        ArgumentValidator.notNullOrEmpty(userId, `userId`);

        const response = await this.axiosClient.put(
            `${this.apiUrl}/${activityId}/${userId}/attending`
        );

        return response.data;
    }

    public async notAttending(activityId: string, userId: string): Promise<IActivityAttendance> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);
        ArgumentValidator.notNullOrEmpty(userId, `userId`);

        const response = await this.axiosClient.put(
            `${this.apiUrl}/${activityId}/${userId}/notAttending`
        );

        return response.data;
    }
}
